// extracted by mini-css-extract-plugin
module.exports = {"root":"HotTip_root__yqrqs","title":"HotTip_title__kPcw_","content":"HotTip_content__4T8ge"};